module.exports = __webpack_public_path__ + "media/images/logo-c28f5e09a59ea18405e2ef3c07a20c83.svg";